// Add your custom JS here.

// ADD CLASS TO ALL EXTERNAL LINKS

// Get all the anchor tags in the document
const anchors = document.getElementsByTagName('a');

// Loop through all the anchor tags
for (let i = 0; i < anchors.length; i++) {

  // Get the href attribute of the anchor tag
  const href = anchors[i].getAttribute('href');

  // Check if the href attribute is an external URL and not the specified ones
  if (href && href.startsWith('http') && !href.includes('gogreenfinancing.com') && !href.includes('gogreenfindev.wpengine.com') && !href.includes('gogreenfinstg.wpengine.com') && !href.includes('go-green.local')) {
    
    // Add the class to the anchor tag
    anchors[i].classList.add('link-external');

  }
}

jQuery(document).ready(function($) {
    $('#main-menu').addClass('menu-level-0'); 
    $('#main-menu > .menu-item').addClass('menu-item-level-0');
    $('#main-menu > .menu-item > a:first-of-type').addClass('menu-link-level-0'); 
    $('#main-menu > .menu-item.menu-item-has-children > a:first-of-type').addClass('menu-link-level-0 panel-toggle-1'); 
        // TODO: add sub-menu name and aria label
        $('.panel-toggle-1, #main-menu .menu-item.menu-item-has-children > a:first-of-type').after('<a href="#" class="panel-toggle panel-toggle-level-1"><span class="sr-only">open sub-menu</span></a>');     
    $('#main-menu > .menu-item.menu-item-has-children > ul').addClass('menu-level-1'); 
    $('#main-menu > .menu-item.menu-item-has-children > ul > .menu-item').addClass('menu-item-level-1');
    $('#main-menu > .menu-item.menu-item-has-children > ul > .menu-item > a:first-of-type').addClass('menu-link-level-1'); 
    $('#main-menu > .menu-item.menu-item-has-children > ul > .menu-item.menu-item-has-children > ul').addClass('menu-level-3'); 
    $('#main-menu > .menu-item.menu-item-has-children > ul > .menu-item.menu-item-has-children > ul > li').addClass('menu-item-level-3'); 
    $('#main-menu > .menu-item.menu-item-has-children > ul > .menu-item.menu-item-has-children > ul > li > a:first-of-type').addClass('menu-link-level-3'); 
    $('#main-menu > .menu-item.menu-item-has-children > ul > .menu-item.menu-item-has-children > ul > li > ul').addClass('menu-level-4'); 

    // hide sub-menus on load
    $('.menu-level-1, .menu-level-2, .menu-level-3, .menu-level-4, .menu-back-link').hide();

    // on click of panel toggle; hide previous level; show current level
    $('.panel-toggle').click(function(){
        $(this).hide();                               //  hide toggle (a)
        $(this).prev().hide();                        //  hide toggle's anchor (a)
        $(this).parent().siblings().hide();           //  hide toggle's parent sibling menus (li)
        $(this).nextAll().fadeIn();                         //  show menu (ul)
        $(this).parent().parent().prev('.menu-back-link').hide();                 //  hide back button
    });

    // TODO: Only add back links to the mobile menu
    $('.menu-back-link').click(function(){
        $(this).prevAll().fadeIn();                         //
        $(this).parent().siblings().fadeIn();               //
        $(this).next().hide();                              //  
        $(this).hide();                                     //  hide back button
        $(this).parent().parent().prev('.menu-back-link').show();                 //  hide back button
    });


});

